/**
 * The letters and the tint in a person's circle, when there is no photo.
 *
 * Moved here from components/ChatMessage.js (which still re-exports both, so
 * nothing that imported them from there changes) when the circle became a
 * shared component: components/Avatar.js draws these underneath a photo, and
 * a photo that is still loading, or missing, or failed, shows exactly the
 * circle that was always there.
 */

/** Two letters at most: the first of the first two words. */
export const initials = (name) => String(name || '?')
  .split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0]).join('').toUpperCase();

/**
 * Which of five tints somebody's initials sit on. Taken from their key, so
 * Marco is the same colour in every conversation and on every visit - the
 * colour is how you spot him in a busy group before you have read a name.
 */
export const hueOf = (key) => {
  let h = 0;
  for (const ch of String(key || '')) h = (h * 31 + ch.charCodeAt(0)) % 997;
  return h % 5;
};
